module.exports = __webpack_public_path__ + "static/cv-Lepee-Laurent-2016-70b9d9874b817c55cc5a9c22d7e4356a.pdf";